import { render } from "./LogoOsSmall.vue?vue&type=template&id=7484c5c8"
const script = {}

import "./LogoOsSmall.vue?vue&type=style&index=0&id=7484c5c8&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__